import ReactSlider, { ReactSliderProps } from "react-slider";
import cls from "./rangeSlider.module.scss";

interface Props<T extends number | readonly number[]>
  extends ReactSliderProps<T> {
  floatingLabel?: boolean;
  color?: string;
  extra?: string;
  trackColor?: string;
  multiple?: boolean;
  value?: T;
}

export default function RangeSlider<T extends number | readonly number[]>(
  _props: Props<T>,
) {
  return (
    <div className={cls.container}>
      {/* @ts-ignore */}
      <ReactSlider
        {..._props}
        renderTrack={(props: any, state: any) => (
          <div
            {...props}
            style={{
              position: "absolute",
              top: "calc(50% - 4px)",
              backgroundColor:
                state.index === 1
                  ? _props?.trackColor || "var(--yellow-rating)"
                  : "var(--grey)",
              width: state.index === 1 ? `${_props?.value ?? 0}%` : "100%",
              height: "8px",
              borderRadius: "50px",
            }}
          />
        )}
      />
    </div>
  );
}
